import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Options, Question as QuestionData } from '../../../data/wizard';
import QuestionOption from './QuestionOption';

import styles from './Question.module.css';

type Props = {
  question: QuestionData;
  isButtonDisabled: boolean;
  isVisible: boolean;
  onButtonClick: (e: SyntheticEvent<HTMLButtonElement>) => void;
  onValueChanged: (id: Options, value: boolean) => void;
};

const Question = ({
  question,
  isButtonDisabled,
  isVisible,
  onButtonClick,
  onValueChanged,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={isVisible ? styles.question : styles.questionHidden}>
      <h3 className={styles.questionText}>
        {t(`Wizard${question.translationKey}.Question`)}
      </h3>
      <p className={styles.hint}>
        {t(`Wizard${question.translationKey}.QuestionHint`)}
      </p>
      <div className={styles.options}>
        {question.options.map(option => (
          <QuestionOption
            key={option.id}
            id={option.id}
            questionId={question.id}
            onChange={e => onValueChanged(option.id, e.target.checked)}
            translationKey={`Wizard${question.translationKey}.Options.${option.translationKey}`}
          />
        ))}
      </div>
      <button
        className={styles.button}
        disabled={isButtonDisabled}
        onClick={onButtonClick}
      >
        {t(`Wizard${question.translationKey}.Button`)}
      </button>
    </div>
  );
};

export default Question;
